import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FaSearch } from 'react-icons/fa';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { API_ENDPOINTS } from '../apiConfig';

const AddCityCentre = () => {
  const [city, setCity] = useState('');
  const [center, setCenter] = useState('');
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState('');

  useEffect(() => {
    fetchCities();
  }, []);

  const fetchCities = async () => {
    try {
      const response = await axios.get(API_ENDPOINTS.GET_CITIES);
      setCities(response.data);
    } catch (err) {
      console.error('Error fetching program:', err);
      toast.error('Failed to fetch pragram.');
    }
  };

  // const fetchCenters = async (cityId) => {
  //   try {
  //     const response = await axios.get(API_ENDPOINTS.GET_CENTERS_BY_CITY(cityId));
  //     // If needed, you can handle fetched centers here
  //   } catch (err) {
  //     console.error('Error fetching centers:', err);
  //     toast.error('Failed to fetch centers.');
  //   }
  // };

  const handleAddCity = async (e) => {
    e.preventDefault();
    try {
      await axios.post(API_ENDPOINTS.ADD_CITY, { name: city });
      toast.success('Program added successfully');
      setCity('');
      fetchCities();
    } catch (err) {
      console.error('Error adding program:', err);
      toast.error('Failed to add program.');
    }
  };

  const handleAddCenter = async (e) => {
    e.preventDefault();
    try {
      await axios.post(API_ENDPOINTS.ADD_CENTER, {
        name: center,
        cityId: selectedCity,
      });
      toast.success('profile added successfully');
      setCenter('');
    } catch (err) {
      console.error('Error adding center:', err);
      toast.error('Failed to add profile');
    }
  };

  return (
    <div className="bg-gray-100 py-8">
      <div className="bg-white max-w-7xl p-6 mx-auto rounded-lg">
        <ToastContainer />
        <h2 className="text-2xl font-bold text-[#080366] mb-4">
          Add Program and  <span className="text-[#fbba00]">Profile</span>
        </h2>

        {/* City Form */}
        <form onSubmit={handleAddCity}>
          <div className="mb-4">
            <label htmlFor="city" className="block font-medium mb-2 text-[#080366]">Program</label>
            <div className="relative">
              <input
                type="text"
                id="city"
                className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter a Program"
                value={city}
                onChange={(e) => setCity(e.target.value)}
              />
              <div className="absolute inset-y-0 right-0 pr-3 flex items-center">
                <FaSearch className="text-gray-400" />
              </div>
            </div>
          </div>
          <button
            type="submit"
            className="bg-[#fbba00] hover:bg-yellow-500 text-[#080366] font-medium py-2 px-4 rounded-md"
          >
            Add Program
          </button>
        </form>

        {/* Center Form */}
        <form onSubmit={handleAddCenter} className="mt-6">
          <div className="mb-4">
            <label htmlFor="city-select" className="block font-medium mb-2 text-[#080366]">Select Program</label>
            <select
              id="city-select"
              className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={selectedCity}
              onChange={(e) => {
                setSelectedCity(e.target.value);
                // fetchCenters(e.target.value);
              }}
            >
              <option value="">Select a Program</option>
              {cities.map((city) => (
                <option key={city._id} value={city._id}>
                  {city.name}
                </option>
              ))}
            </select>
          </div>
          <div className="mb-4">
            <label htmlFor="center" className="block font-medium mb-2 text-[#080366]">Profile</label>
            <input
              type="text"
              id="center"
              className="w-full border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter a Profile"
              value={center}
              onChange={(e) => setCenter(e.target.value)}
            />
          </div>
          <button
            type="submit"
            className="bg-[#fbba00] hover:bg-yellow-500 text-[#080366] font-medium py-2 px-4 rounded-md"
          >
            Add Profile
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddCityCentre;
